module.exports = __webpack_public_path__ + "img/no_data.c11875e2.svg";